import { http } from '@utils/interceptor'
import { ActionContext, Module } from 'vuex'

import { URL_GET_SHOP_DETAIL, URL_GET_COMMENT, URL_GET_COMMENT2, URL_GET_SERVICE_ITEM, URL_GET_USERINFO, URL_GET_COUPON, URL_SEND_COUPON, URL_GET_DAODIAN_CATEGORY, ShopTypes } from './config'

import { removeSpuIds } from './childbirth-service-package'
interface IUserInfoParams {
  uid: string | number
  skey: string | number
}
export const getUserInfo = async (params: IUserInfoParams) => {
  const _temp = await http.get(URL_GET_USERINFO, {
    params
  })

  if (_temp.errno * 1 === 0) {
    return _temp.data
  } else {
    console.error(`Error Warning: cause by ${URL_GET_USERINFO}, request params is `, params, `and response is`, _temp)
    return {}
  }
}
interface IShopDetailParams {
  businessId: string | number
  longitude: string | number
  latitude: string | number
}

/**
 * 描述 获取门店信息
 * @date 2020-11-30
 * @param {any} params:IShopDetailParams
 * @returns {any}
 */
export const getShopDetail = async (params: IShopDetailParams) => {
  const _temp = await http.get(URL_GET_SHOP_DETAIL, {
    params
  })
  if (_temp.code * 1 === 1) {
    return _temp.data
  } else {
    console.error(`Error Warning: cause by ${URL_GET_SHOP_DETAIL}, request params is `, params, `and response is`, _temp)
    return {}
  }
}

export async function getServiceItem(params: any) {
  const _temp = await http.post(URL_GET_SERVICE_ITEM, params)
  if (_temp.code * 1 === 1) {
    return _temp.data
  } else {
    console.error(`Error Warning: cause by ${URL_GET_SERVICE_ITEM}, request params is `, params, `and response is`, _temp)
    return {}
  }
}

interface IShopComment {
  businessId: any
  page: number
  size: number
  type: 9
  orderBy: 1
  show_user: number
}
/**
 * 描述 获取门店下用户评论
 * @date 2020-11-30
 * @param {any} params:IShopComment
 * @returns {any}
 */
export const getComment = async (params: IShopComment) => {
  try {
    const _temp = await http.get(URL_GET_COMMENT, {
      params
    })
    if (_temp.code * 1 === 1) {
      return _temp.data
    } else {
      console.error(`Error Warning: cause by ${URL_GET_COMMENT}, request params is `, params, `and response is`, _temp)
      return {}
    }
  } catch (error) {
    console.log('error is ', error)
  }
}
interface IShopComment2 {
  objectId: any
  page: number
  size: number
  type: number
  skey: number
  uid: number
}
/**
 * 描述 获取成长加商户的用户评论
 * @date 2020-11-30
 * @param {any} params:IShopComment2
 * @returns {any}
 */
export const getComment2 = async (params: IShopComment2) => {
  try {
    const _temp = await http.get(URL_GET_COMMENT2, {
      params
    })
    if (_temp.code * 1 === 1) {
      return _temp.data
    } else {
      console.error(`Error Warning: cause by ${URL_GET_COMMENT2}, request params is `, params, `and response is`, _temp)
      return {}
    }
  } catch (error) {
    console.log('error is ', error)
  }
}

/**
 * 描述 获取门店下优惠券列表
 * @date 2020-11-30
 * @param {any} params:{ shopId: string | number }
 * @returns {any}
 */
export const getCoupon = async (params: { shopId: string | number }) => {
  const _temp = await http.get(URL_GET_COUPON, {
    params
  })
  if (_temp.code * 1 === 1) {
    return _temp.data
  } else {
    console.error(`Error Warning: cause by ${URL_GET_COUPON}, request params is `, params, `and response is`, _temp)
    return {}
  }
}

/**
 * 描述 领取门店下优惠券
 * @date 2020-11-30
 * @param {any} params:{ couponCode: string; uid: number; skey: string }
 * @returns {any}
 */
export const sendCoupon = async (params: { couponCode: string; uid: number; skey: string }) => {
  return await http.get(URL_SEND_COUPON, {
    params
  })
}

/**
 * 描述 查询到店品类
 * @param {any} params: { businessType?: string | number }
 * @returns {any}
 */
export const getDaodianCategory = async (params: { businessType?: string | number }) => {
  const _temp = await http.get(URL_GET_DAODIAN_CATEGORY, {
    params
  })
  if (_temp.code * 1 === 1) {
    return _temp.data
  } else {
    console.error(`Error Warning: cause by ${URL_GET_DAODIAN_CATEGORY}, request params is `, params, `and response is`, _temp)
    return []
  }
}

/* 区分商户类型 */
export const distinguishShop = async (context: ActionContext<IShopState, any>) => {
  const shopDetail = context.state.shopDetail
  if (shopDetail) {
    // 是否为育儿门店，非成长加门店
    context.commit('setShopYuer', shopDetail.businessType == 21)

    // 所有的到店品类
    let ARRIVAL_SHOP_CATEGORIES: any[] = (await getDaodianCategory({})) || []
    ARRIVAL_SHOP_CATEGORIES = ARRIVAL_SHOP_CATEGORIES.map(c => c.categoryId)
    // 商家的签约品类列表
    const contractCategoryList = shopDetail.contractCategoryList || []
    // 是否包含到店品类
    const isArrival = contractCategoryList.some((c: any) => ARRIVAL_SHOP_CATEGORIES.indexOf(c.category4) > -1)
    // 是否自营
    const isself = shopDetail.isself == 1
    if (isArrival && !isself) {
      // 到店、联营，再根据一级、二级、三级品类区别门店类型
      if (shopDetail.storeCategory2 === '孕产服务') {
        context.commit('setShopType', ShopTypes.Pregnancy)
      } else if (shopDetail.storeCategory === '新生儿纪念品') {
        context.commit('setShopType', ShopTypes.Children)
      } else if (shopDetail.storeCategory2 === '孕婴童摄影') {
        context.commit('setShopType', ShopTypes.Photography)
      } else if (shopDetail.storeCategory1 === '教育培训') {
        context.commit('setShopType', ShopTypes.Education)
      } else {
        context.commit('setShopType', ShopTypes.Common)
      }
    } else if (isself && shopDetail.businessType === 24) {
      // 自营摄影
      context.commit('setShopType', ShopTypes.Common)
    } else {
      // 非到店、或自营，用小儿纪念品样式
      context.commit('setShopType', ShopTypes.Children)
    }
  }
}

interface IShopState {
  shopDetail: any
  shopType: string
  shopYuer: boolean
  serviceDetail: any
  commentDetail: any
  couponDetail: any
}

export const STORE: Module<IShopState, any> = {
  namespaced: true,
  state: () => ({
    shopDetail: null,
    shopType: ShopTypes.Common,
    shopYuer: false,
    serviceDetail: {},
    commentDetail: {},
    couponDetail: {}
  }),
  mutations: {
    setShopDetail(state: IShopState, payload: any) {
      state.shopDetail = payload
    },
    setShopType(state: IShopState, payload: any) {
      state.shopType = payload
    },
    setShopYuer(state: IShopState, payload: any) {
      state.shopYuer = payload
    },
    setServiceDetail(state: IShopState, payload: any) {
      state.serviceDetail = payload
    },
    setCommentDetail(state: IShopState, payload: any) {
      state.commentDetail = payload
    },
    setCouponDetail(state: IShopState, payload: any) {
      state.couponDetail = payload
    }
  },
  getters: {},
  actions: {
    async getShopDetailAction(context: ActionContext<IShopState, any>, par: IShopDetailParams) {
      const res: ResponseCode = await getShopDetail({
        businessId: par.businessId,
        latitude: par.latitude,
        longitude: par.longitude
      })
      context.commit('setShopDetail', res)
      await distinguishShop(context)
    },

    async getServiceItemAction(context: ActionContext<IShopState, any>, par: { storeId: string | number; limit: number; cityId: number; isSpec: number }) {
      const res = await getServiceItem({
        ...par,
        limit: par.limit || 100
      })
      // 清除服务待产包商品
      res.list = await removeSpuIds(res?.list ?? [])
      context.commit('setServiceDetail', res)
      return ''
    },

    async getCommentAction(context: ActionContext<IShopState, any>, par: IShopComment) {
      const res: ResponseCode = await getComment({
        businessId: par.businessId,
        size: par.size,
        page: par.page,
        type: 9,
        orderBy: 1,
        show_user: par.show_user
      })
      context.commit('setCommentDetail', res)
    },

    async getCommentAction2(context: ActionContext<IShopState, any>, par: IShopComment2) {
      const res: ResponseCode = await getComment2({
        objectId: par.objectId,
        size: par.size,
        page: par.page,
        type: par.type,
        skey: par.skey,
        uid: par.uid
      })
      context.commit('setCommentDetail', res)
    },

    async getCouponAction(context: ActionContext<IShopState, any>, par: { shopId: string | number }) {
      const res: ResponseCode = await getCoupon(par)
      context.commit('setCouponDetail', res)
    },

    async sendCouponAction(context: ActionContext<IShopState, any>, par: { couponCode: string; uid: number; skey: string }) {
      return await sendCoupon(par)
    }
  }
}
